import { AxiosError } from 'axios';

/**
 * Standard error handler for async thunks that rejects with Axios response data.
 * Replaces the common `if (error instanceof AxiosError && error.response)` catch pattern.
 *
 * Always either calls `rejectWithValue(data)` (and returns its result) or re-throws.
 */
export function handleThunkError(
  error: unknown,
  rejectWithValue: (value: unknown) => unknown
): unknown {
  if (error instanceof AxiosError && error.response) {
    return rejectWithValue(error.response.data);
  }
  throw error;
}

/**
 * Error handler for async thunks that rejects with both data and status.
 * Used by authSlice and tripTokenSlice where the status code drives reducer logic.
 */
export function handleThunkErrorWithStatus(
  error: unknown,
  rejectWithValue: (value: unknown) => unknown
): unknown {
  if (error instanceof AxiosError && error.response) {
    return rejectWithValue({ data: error.response.data, status: error.response.status });
  }
  throw error;
}
